<app-checkbox
  [ngModel]="checkboxValue"
  [checkBoxVariant]="'multiselect'"
  (changeValue)="changeItemSelection($event.checked)"
></app-checkbox>
